import { apiUrl, authHeaders, authJsonHeaders } from "./httpAuth";

export async function fetchArmasAll() {
    const res = await fetch(apiUrl("api/armas/all"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function createArma(payload) {
    const res = await fetch(apiUrl("api/armas/create"), {
        method: "POST",
        headers: authJsonHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json().catch(() => null);
}

export async function updateArma(armaId, payload) {
    const res = await fetch(apiUrl(`api/armas/update/${armaId}`), {
        method: "PUT",
        headers: authJsonHeaders(),
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json().catch(() => null);
}

export async function deleteArma(armaId) {
    const res = await fetch(apiUrl(`api/armas/delete/${armaId}`), {
        method: "DELETE",
        headers: authHeaders(),
    });
    return res; // la UI decide qué hacer con el texto
}
